import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import { ControlPanel } from 'modules/controlPanel';
import { updateQuery } from 'modules/router/actions';
import moment from 'moment';
import SearchFeedListContainer from './SearchFeedListContainer';
import { fetchSearchFeedList } from '../actions';
import { setCollection } from 'modules/collection/actions';
import {Affix, Button, BackTop} from 'antd';
import * as notification from 'modules/notification';
import './style.css';
import { logAsync } from 'helpers/elogAsync';

const container = connect(
  createSelector(
    (state) => ({
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      userId: _.get(state, 'me.id'),
      model: _.get(state, 'search.feed'),
      feedGlobalIds: _.get(state, 'search.feed.data'),
      collection: _.get(state, 'collection.globalIds'),
      permission: _.get(state, 'me.permission.favoriteQuota'),
    }),
    (state) => {
      return {
        ...state
      }
    }
  )
)

class Search extends Component {

  componentDidMount() {
    const {dispatch, query, subjects} = this.props;
    if (!_.get(query, 'startDate')) {
      dispatch(updateQuery({
        startDate: moment().subtract(6, 'd').startOf('day'),
        endDate: moment().endOf('day')
      }))
    }
    if (!_.get(query, 'mediaType')) {
      const subjectId = _.get(query, 'subjectId');
      const subject = subjects[subjectId];
      const mediaTypes = _.keys(_.get(subject, 'queries'))
      if (_.get(mediaTypes, 'length') == 1) {
        dispatch(updateQuery({
          mediaType: _.head(mediaTypes)
        }))
      }
    }
  }

  dispatchFetchFeedList = (action) => {
    const { dispatch } = this.props;
    dispatch(fetchSearchFeedList(action))
  }

  handleCollection = () => {
    const {dispatch, userId, feedGlobalIds, permission, collection} = this.props;
    const globalIds = _.map(feedGlobalIds, 'globalId');
    if (_.get(collection, 'length', 0) + globalIds.length < _.get(permission, 'limit')) {
      dispatch(setCollection({
        type: 'ADD',
        globalId: globalIds,
        userId: userId,
      }))
      .then(() =>{
        notification.showClippingSuccess(true);
        const {register_email} = localStorage;
        logAsync({
          type: 'sPOP-add-collection',
          data: {
            globalId: globalIds,
            user: register_email
          }
        })
      })
      .catch(()=>{
        notification.error(t('commonClippingFail'));
      });
    } else {
      const canCollectionCount = _.get(permission, 'limit') - collection.length;
      dispatch(setCollection({
        type: 'ADD',
        globalId: _.take(globalIds, canCollectionCount),
        userId: userId,
      }))
      .then(() => {
        notification.showClippingFull();
        const {register_email} = localStorage;
        logAsync({
          type: 'sPOP-add-collection',
          data: {
            globalId: _.take(globalIds, canCollectionCount),
            user: register_email
          }
        })
      })
      .catch(()=>{
        notification.error(t('commonClippingFail'));
      });
    }

  }

  render() {
    const {query, subjects, model} = this.props;
    const subjectId = _.get(query, 'subjectId');
    const subject = subjects[subjectId];
    return (
      <div className="margin-left-md" style={{background: '#fff'}}>
        <div className="subject-name">
          <span>{_.get(subject, 'name')}</span>
          <span className='count'>
            {model.count <= 100000 && !model.isLoading &&
              <span>(共約{model.count}條結果)</span>
            }
            {model.count > 100000 && !model.isLoading &&
              <span>(共約100,000+條結果)</span>
            }
          </span>
        </div>
        <ControlPanel />
        <SearchFeedListContainer dispatch={this.dispatchFetchFeedList}/>
        <div className="all-collection" onClick={this.handleCollection}>收藏全部</div>
      </div>
    )
  }
}

export default container(Search)



/** WEBPACK FOOTER **
 ** ./src/app/modules/search/components/Component.js
 **/